import { useGlobal } from "@root/hooks/useGlobal";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {};

const GlobalContext = createContext<any>(defaultState);

interface GlobalContextProviderProps {
  children: ReactNode;
}

export const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  const data = useGlobal();
  return (
    <GlobalContext.Provider value={data}>{children}</GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
